import { IAffiliatePayoutDestination } from "@/models/affiliate";
import { IAffiliateReferral, IAffiliateTier } from "@/models/affiliate";
import { IBrand } from "@/models/brands";
import { IClient } from "@/models/clients";
import { ICurrency } from "@/models/constants";
import { IEmail } from "@/models/emails";
import { IPricelist } from "@/models/products";
import { IStatus } from "@/models/statuses";
import { IUser } from "@/models/users";

export enum MultiCurrencyBalance {
  FORBID = 0,
  ALLOW = 1,
  INHERIT = 2
}

export enum AutoConsumeWallet {
  NO = 0,
  YES = 1,
  INHERIT = 2
}

export interface IAccount {
  affiliate_payout_destination_id?: IAffiliatePayoutDestination["id"] | null;
  affiliate_payout_paypal_email_id: IEmail["id"] | null;
  affiliate_referral?: IAffiliateReferral;
  affiliate_tier_id: IAffiliateTier["id"] | null;
  auto_consume_on_due_date: AutoConsumeWallet;
  brand: IBrand;
  brand_id: IBrand["id"];
  client?: IClient[]; // Requires relation with=clients
  clients?: IClient[]; // Requires relation with=clients
  created_at: string;
  currency_id: ICurrency["id"];
  id: string;
  multi_currency_balance: MultiCurrencyBalance;
  name: string;
  pivot: { client_id: IClient["id"]; account_id: IAccount["id"] };
  preferred_payment_currency?: ICurrency; // Requires relation
  preferred_payment_currency_id: ICurrency["id"] | null;
  pricelist: IPricelist;
  pricelist_id: IPricelist["id"];
  reseller_account_id: IAccount["id"] | null;
  status_id: IStatus["id"];
  topup_enabled: boolean;
  updated_at: string;
  user_id: IUser["id"];
}
